import { DEFAULT_API_CONFIG } from './apiConfig';
import { createNewUserWithRole } from './account.service';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/callcenter`;
const baseOrderRoute = `${url}/orders`;

export const getAllCallCenterUsers = async () => {
  const url = `${baseRoute}/users`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getCallCenterUserById = async id => {
  const url = `${baseRoute}/users/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const createCallCenterUser = async user => {
  user.role = 'CALLCENTER';
  const url = `${baseRoute}/user`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const putCallCenterUser = async user => {
  user.role = 'CALLCENTER';
  const url = `${baseRoute}/users/${user.callCenterUserId}`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
}; 

export const releaseOrder = async (orderLineId, interviewConducted, participatesInIQ = null, iqPhoneNumber = null) => {
  let headers = getHeaders();
  const params = new URLSearchParams();
  
  if (interviewConducted != null) {
    params.append('interviewConducted', interviewConducted);
  }
  if (participatesInIQ != null) {
    params.append('participatesInIQ', participatesInIQ);
  }
  if (iqPhoneNumber != null) {
    params.append('iqPhoneNumber', iqPhoneNumber);
  }
  
  const queryString = params.toString();
  const queryParams = queryString ? `?${queryString}` : '';
  
  const response = await fetch(`${baseOrderRoute}/bulkReleaseCallAheadOrders${queryParams}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify([orderLineId]),
  });

  if (response.ok) return;
  const json = await response.json();
  return Promise.reject(json);
};
